import React from 'react';
import { FaChevronDown, FaChevronRight, FaWhatsapp } from 'react-icons/fa';
import SignIn from 'src/pages/SignIn';
import FadeInOnScroll from '../../../../../../components/FadeInOnScroll';

import ContainerLine from "../../../../../../components/UIComponents/ContainerLine";
import { ContainerLineUI } from "../../../../../../components/UIComponents/ContainerLine/styles";

import { ParagraphUI } from "../../../../../../components/UIComponents/Paragraph/styles";
import { ParagraphHighlightUI, TitleHighlightUI } from '../../../../../../components/UIComponents/TitleHighlight/styles';
import VideoBackground from "../../../../../../components/VideoBackground";
import { urlWebsite } from "../../../../../../config";
import { scrollToID } from '../../../../../../utils/scrollTo';
import RenderPageList from '../../modules/RenderList';
import RenderPageImages from "../../modules/RenderPageImages";

const HomeTemplate = ({ pageContent, theme }: Record<string, any>) => {
  const { hash } = pageContent;

  return (
    <>

      <ContainerLineUI className=' full-width row-to-column-reverse gap' id={hash} style={{ background: pageContent.background_image ? `url("${urlWebsite}/${pageContent?.background_image}")` : pageContent?.theme_data?.background ? pageContent?.theme_data?.background : '#fff' }} >


        <img src='/logo.png' style={{ width: '100%', maxWidth: '400px' }} />

        <SignIn />

      </ContainerLineUI>
    </>
  );


}

export default HomeTemplate;